<ng-container *ngIf="summary">

  <div class="row" *ngIf="summary.CurrentGarageVisit">
    <div class="col-12 ">
      <div class="menu-box-visit m-2 p-2">
        <div class="menu-box-visit-text p-1">
          Aktualne umówienie
        </div>
        <div class="menu-box-visit-text p-1">
          {{ summary.CurrentGarageVisit.Date| date:'yyyy.MM.dd  HH:mm'}}
        </div>
        <div class="menu-box-visit-text p-1">
          {{ summary.CurrentGarageVisit.Garage.Name}}
        </div>
        <div class="menu-box-visit-text p-1">
          <!--{{ summary.CurrentGarageVisit.Garage.City}}-->
          {{ summary.CurrentGarageVisit.Garage.Street}}
        </div>
        <div class="menu-box-visit-text p-1" *ngIf="summary.CurrentGarageVisit.Garage.Telephone">
          tel: {{ summary.CurrentGarageVisit.Garage.Telephone}}
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="summary.CurrentGarageVisitRequest">
    <div class="col-12 ">
      <div class="menu-box-visit m-2 p-2">
        <div class="menu-box-visit-text p-1">
          Zarejestrowane zgłoszenie z prośbą o umówienie wizyty.
        </div>
        <div class="menu-box-visit-text p-1">
          {{ summary.CurrentGarageVisitRequest.Garage.Name}}
        </div>
        <div class="menu-box-visit-text p-1">
          <!--{{ summary.CurrentGarageVisitRequest.Garage.City}}-->
          {{ summary.CurrentGarageVisitRequest.Garage.Street}}
        </div>

        <div class="menu-box-visit-text p-1" *ngIf="summary.CurrentGarageVisitRequest.Garage.Telephone">
          tel: {{ summary.CurrentGarageVisitRequest.Garage.Telephone}}
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="summary.AldGarage">
    <div class="col-12 ">
      <div class="menu-box-visit m-2 p-2">
        <div class="menu-box-visit-text p-1">
          Zarejestrowano zlecenie ustawienia domyślnego serwisu. Dostarczenie opon może potrwać około 5 dni roboczych.
        </div>
        <div class="menu-box-visit-text p-1">
          {{ summary.AldGarage.Name}}
        </div>
        <div class="menu-box-visit-text p-1">
          <!--{{ summary.AldGarage.City}}-->
          {{ summary.AldGarage.Street}}
        </div>

        <div class="menu-box-visit-text p-1" *ngIf="summary.AldGarage.Telephone">
          tel: {{ summary.AldGarage.Telephone}}
        </div>
      </div>
    </div>
  </div>

  <div class="row display-flex" *ngIf="summary.IsDefaultGarageRequired">
    <div class="col-12 p-2">
      <div class="menu-box p-2 p-2" (click)="onSetDefaultGarage()">
        <div class="menu-box-text p-1">
          Brak opon. Naciśnij tutaj aby wybrać domyślny serwis do którego mają być dostarczane opony.
        </div>
        <div class="menu-box-icon p-1">
          <i class="fa fa-info-circle fa-2xl" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>


  <div class="row display-flex">
    <div class="col-6 p-2">
      <div class="menu-box p-2" (click)="onCarDetails()">
        <div class="menu-box-text p-1" *ngIf="summary.IsCarDetailsValid">
          Dane użytkownika
        </div>

        <div class="menu-box-text p-1" *ngIf="!summary.IsCarDetailsValid">
          Dane użytkownika. <span style="color: darkred">Proszę uzupełnić.</span>
        </div>
        <div class="menu-box-icon p-1">
          <i class="fa fa-id-card fa-2xl" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div class="col-6 p-2">
      <div [ngClass]="summary.VisitAmount > 0 ? 'menu-box p-2' :'menu-box-disabled p-2'" (click)="summary.VisitAmount > 0 ? onVisits() : return;">
        <div class="menu-box-text p-1 float-right">
          <span [ngClass]="summary.VisitAmount > 0 ? 'badge badge-success p-1' :'badge badge-light p-1'">{{summary.VisitAmount}}</span>
        </div>
        <div class="menu-box-text p-1">
          Lista umówień
        </div>
        <div class="menu-box-icon p-1">
          <i class="fa fa-calendar-check-o fa-2xl" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="row display-flex">
    <div class="col-6 p-2">
      <div [ngClass]="(summary.DepositeAmount > 0 && summary.IsCarDetailsValid) ? 'menu-box p-2' :'menu-box-disabled p-2'" (click)="(summary.DepositeAmount > 0 && summary.IsCarDetailsValid) ? onDeposites() :  return;">
        <div class="menu-box-text p-1 float-right">
          <span [ngClass]="summary.DepositeAmount > 0 ? 'badge badge-success p-1' :'badge badge-light p-1'">{{summary.DepositeAmount}}</span>
        </div>
        <div class="menu-box-text p-1" *ngIf="summary.DepositeAmount == 0 || !summary.IsVisitAvailable">
          Opony w depozycie
        </div>

        <div class="menu-box-text p-1" *ngIf="(summary.DepositeAmount > 0) && summary.IsVisitAvailable">
          Depozyty - Zarezerwuj termin wymiany lub zleć relokację
        </div>

        <div class="menu-box-icon p-1">
          <i class="fa fa-archive fa-2xl" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div class="col-6 p-2">
      <div [ngClass]="(summary.OrderAmount > 0 && summary.IsCarDetailsValid) ? 'menu-box p-2' :'menu-box-disabled p-2'" (click)="(summary.OrderAmount > 0 && summary.IsCarDetailsValid) ? onTyreOrders() : return;">
        <div class="menu-box-text p-1 float-right">
          <span [ngClass]="summary.OrderAmount > 0 ? 'badge badge-success p-1' :'badge badge-light p-1'">{{summary.OrderAmount}}</span>
        </div>
        <div class="menu-box-text p-1" *ngIf="summary.OrderAmount == 0 || !summary.IsVisitAvailable">
          Opony zamówione
        </div>

        <div class="menu-box-text p-1" *ngIf="(summary.OrderAmount > 0) && summary.IsVisitAvailable">
          Opony zamówione - Zarezerwuj termin wymiany
        </div>

        <div class="menu-box-icon p-1">
          <i class="fa fa-shopping-cart fa-2xl" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="row display-flex">

    <div class="col-6 p-2">
      <div [ngClass]="(summary.RelocationAmount > 0 && summary.IsCarDetailsValid) ? 'menu-box  p-2' :'menu-box-disabled p-2'" (click)="(summary.RelocationAmount > 0 && summary.IsCarDetailsValid) ? onRelocationOrders() : return;">
        <div class="menu-box-text p-1 float-right">
          <span [ngClass]="summary.RelocationAmount > 0 ? 'badge badge-success p-1' :'badge badge-light p-1'">{{summary.RelocationAmount}}</span>
        </div>
        <div class="menu-box-text p-1">
          Lista relokacji
        </div>
        <div class="menu-box-icon p-1">
          <i class="fa fa-shopping-cart fa-2xl" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div class="col-6 p-2">
      <div class="menu-box p-2" (click)="logout()">
        <div class="menu-box-text p-1">
          Wyloguj
        </div>
        <div class="menu-box-icon p-1">
          <i class="fa fa-sign-out fa-2xl" aria-hidden="true"></i>
        </div>
      </div>
    </div>

  </div>

  <!--<div class="row">
    <div class="col-12 p-2">
      <div class="menu-box p-2">
        <div>
          <textarea placeholder="Wiadomość do opiekuna (minimum 10 znaków)" [(ngModel)]="requestSendMessage.Item" style="font-size: 12px; width: 100%;" [attr.rows]="5"></textarea>
        </div>
        <div class="text-right" style="width:100%">
          <button style="margin-bottom: 10px; background-color: #00bd3f; max-width: 200px; " [disabled]="!IsMessageSendValid()" class="btn btn-primary form-control" (click)="onSendMessage()">
            Wyślij wiadomość
          </button>
        </div>
      </div>
    </div>
  </div>-->

</ng-container>


<ng-container *ngIf="!summary">
  <div class="container z-index-master">
    <div class="row align-items-center">
      <div class="col-md-12">
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
